import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TelusAccordionComponent } from './accordion';
import { TelusFormModule } from '../form/form.module';
import { TableModule } from '../table/table.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TelusFormModule,
    TableModule,
  ],
  declarations: [TelusAccordionComponent],
  exports: [TelusAccordionComponent],
})
export class TelusAccordionModule {}
